import { motion } from "framer-motion";
import { ArrowRight, FileDown, Phone } from "lucide-react";
import { Button } from "./ui/button";

const HERO_IMG =
  "https://images.unsplash.com/photo-1639037179118-d1a475030792?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBjaXR5JTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4MzQxODY0Nnww&ixlib=rb-4.1.0&q=85";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Hero = () => {
  return (
    <section id="home" className="relative pt-20 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={HERO_IMG} alt="Aerial drone survey view across an infrastructure project in India" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/20" />
        <div className="absolute inset-0 hero-grid opacity-60" />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 lg:py-36">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 rounded-sm border border-[#10193f]/20 bg-white/70 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-[#10193f]"
          >
            <span className="h-2 w-2 rounded-full bg-[#8b8f99]" />
            DGCA-Aware Operations · Since 2018 · Navi Mumbai
          </span>

          <h1 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-[#10193f] leading-[1.05]">
            India&apos;s Trusted Drone Survey &{" "}
            <span className="text-[#8b8f99]">Construction Monitoring</span> Company
          </h1>

          <p className="mt-6 text-base sm:text-lg text-[#52525b] max-w-2xl leading-relaxed">
            Survey-grade drone mapping, LiDAR survey, industrial inspection and
            construction progress monitoring for infrastructure projects across
            India.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row flex-wrap gap-3">
            <Button
              data-testid="hero-cta-quote"
              onClick={() => scrollTo("#contact")}
              className="rounded-sm bg-[#10193f] hover:bg-[#1a2350] text-white font-semibold h-12 px-7 text-base"
            >
              Get Free Quote <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button
              data-testid="hero-cta-profile"
              variant="outline"
              onClick={() => scrollTo("#contact")}
              className="rounded-sm border-[#10193f]/25 text-[#10193f] hover:bg-[#10193f]/5 font-semibold h-12 px-7 text-base"
            >
              <FileDown className="mr-2 h-4 w-4" /> Download Company Profile
            </Button>
            <a href="tel:+917715972997">
              <Button
                data-testid="hero-cta-call"
                variant="outline"
                className="rounded-sm border-[#10193f]/25 text-[#10193f] hover:bg-[#10193f]/5 font-semibold h-12 px-7 text-base w-full"
              >
                <Phone className="mr-2 h-4 w-4" /> Call Now
              </Button>
            </a>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
            {[
              ["500+", "Projects"],
              ["8+", "Years"],
              ["25+", "Cities"],
            ].map(([n, l]) => (
              <div key={l} data-testid={`hero-stat-${l}`}>
                <div className="font-heading text-3xl font-black text-[#10193f]">{n}</div>
                <div className="text-xs font-semibold uppercase tracking-wider text-[#52525b] mt-1">{l}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
